<div>

  <section class="form-tasklist">
    <mat-accordion class="retrofit-headers-align">
      <!--Sg-->
      @if (this.steps.sg.show()) {
        <mat-expansion-panel id="sg-panel"
          [expanded]="this.steps.sg.expanded()" (opened)="setApprovalTask('sg')">
          <mat-expansion-panel-header [collapsedHeight]="'60px'" [expandedHeight]="'60px'">
            <mat-panel-title>
              @if (isSgWaitList) {
                <div>
                  <mat-icon class="retrofit-task-icon primary">error</mat-icon>
                </div>
              }
              @if (!isSgWaitList) {
                <div>
                  @if (taskSG.statusCode ===700000000 && application.sGStatus ===700000002) {
                    <div>
                      <mat-icon class="retrofit-task-icon primary"><i class="fa-solid fa-square-1 fa-sm"></i></mat-icon>
                    </div>
                  }
                  @if (taskSG.statusCode ===700000003 && !application.envelopeOkToVerify && application.sGStatus ===700000002 ) {
                    <div>
                      <mat-icon class="retrofit-task-icon primary"><i class="fa-solid fa-square-1 fa-sm"></i></mat-icon>
                    </div>
                  }
                  @if (taskSG.statusCode ===700000003 && application.envelopeOkToVerify  && application.sGStatus ===700000002) {
                    <div>
                      <mat-icon class="retrofit-task-icon accepted"><i class="fa-solid fa-square-check fa-sm"></i></mat-icon>
                    </div>
                  }
                  @if (application.sGStatus ===700000003) {
                    <div>
                      <mat-icon class="retrofit-task-icon rejected"><i class="fa-solid fa-circle-exclamation fa-sm "></i></mat-icon>
                    </div>
                  }
                  @if (application.sGStatus ===700000004) {
                    <div>
                      <mat-icon class="retrofit-task-icon accepted"><i class="fa-solid fa-square-check fa-sm"></i></mat-icon>
                    </div>
                  }
                  @if (application.sGStatus ===700000002 && taskSG.statusCode ===700000002) {
                    <div>
                      <mat-icon class="retrofit-task-icon rejected"><i class="fa-solid fa-triangle-exclamation fa-sm"></i></mat-icon>
                    </div>
                  }
                  @if (application.sGStatus ===700000002 && taskSG.statusCode ===700000001) {
                    <div>
                      <mat-icon class="retrofit-task-icon primary"><i class="fa-solid fa-square-check fa-sm"></i></mat-icon>
                    </div>
                  }
                </div>
              }
              <div>
                <div class="retrofit-task-name">Supplemental Grant</div>
                @if (application.sGStatus !==700000003 && application.sGStatus !==700000004 ) {
                  <small class="retrofit-task-status">
                  {{ sgheadingstatus }} </small>
                }
                @if (application.sGStatus ===700000003 ) {
                  <small class="retrofit-task-status" style="color:#c3391d ;"> {{ sgheadingstatus }} </small>
                }
                @if (application.sGStatus ===700000004) {
                  <small class="retrofit-task-status" style="color:#2a7f48 ;"> {{ sgheadingstatus }} </small>
                }
              </div>
            </mat-panel-title>
            <mat-panel-description fxShow.gt-sm="true" fxShow="false">
              <span class="retrofit-task-summary todo">
                {{ 'Low-to-moderate income assessment' }}
              </span>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="retrofit-task-body" [ngClass]="{ disabledDiv: isreadonly }">
            <div fxLayout="row" fxLayout.lt-md="column wrap" fxLayoutGap="25px">
              <div fxFlex="75%">
                <!-- Sg WaitList -->
                @if (application && isHomeowner() && isSgWaitList) {
                  <div>
                    <div class="retrofit-form-text">
                      <div [innerHTML]="textSGMessage"></div>
                    </div>
                    <br />
                    <mat-checkbox class="retrofit-form-text" id="confirmReviewedTerms" name="confirmReviewedTerms"
                      (change)="onWithChangeEventTerms($event)">
                     
                        I acknowledge that I will be removed from the Supplemental Grant wait list.
                     
                    </mat-checkbox>
                    <div style="margin-top: 18px;" class="retrofit-form-text">
                      <button mat-raised-button style="white-space: pre-wrap !important;" color="primary" [disabled]="!withdrawagreeToTerms"
                        (click)="onwithdrawSG()">
                        WITHDRAW FROM WAIT LIST
                      </button>
                    </div>
                  </div>
                }
                <!-- Sg Self Eligible, Qualified,Not Qualified -->
                @if (isHomeowner() && !isSgWaitList) {
                  <div>
                    <p class="retrofit-task-item-title">Income Assessment</p>
                    <div class="retrofit-form-text">
                      <div [innerHTML]="textSGMessage"></div>
                    </div>
                    <br>
                      <ebb-portal-tax-list
                        [disableSgSubmitButton]="disableSgSubmitButton"
                        [context]="'PreRetrofit'"
                        [title]="'Income Verification Requests'"
                        [application]="application"
                        [task]="taskSG"
                        [email]="email"
                        [listHelp]="listHelp"
                        (onEmitOpenDocuUrlEvent)="onEmitOpenDocuUrl($event)"
                        (resubmitTaxRequestDataEvent)="onEmitResubmitTaxRequestData($event)"
                        (anyRejected4506cItemsDisplayedEvent)="onEmitAnyRejected4506cItemsDisplayed($event)"
                        (submitTaxRequestDataEvent)="onEmitsubmitTaxRequestData($event)"
                        (ondeleteIVR)="onIVRChange($event)"
                        >
                      </ebb-portal-tax-list>
                      <br>
                        @if (formAutoSave) {
                          <div style="display: block; margin-top: 12px; margin-bottom: 15px;">
                            <mat-progress-bar mode="indeterminate" style="width: 300px;">
                            </mat-progress-bar>
                          </div>
                        }
                        @if (application.sGStatus ===700000002 ) {
                          <div>
                            @if ((this.sg4506cCount >= this.application.sGmaxrequests && !application.envelopeOkToVerify) || (this.sg4506cCount + this.sg4506cRejectedCount >= this.application.sGmaxrequests && this.sg4506cRejected)) {
                              <div class="retrofit-form-text">
                                <div [innerHTML]="sgmax4506climtmsg"></div>
                              </div>
                            }
                            <div  class="retrofit-form-text" [ngClass]="{disabledDiv: this.disableSgSubmitButton}">
                              @if (!application.envelopeOkToVerify) {
                                <div>
                                  <button mat-stroked-button color="primary" class="button-wrap" (click)="onClickSubmitTaxRequestData()">
                                    <mat-icon>add</mat-icon>
                                    @if (taskSG.approvalTaskItems.length ===0) {
                                      <span>SUBMIT INCOME VERIFICATION FORM</span>
                                    }
                                    @if (taskSG.approvalTaskItems.length !==0) {
                                      <span>SUBMIT ANOTHER INCOME VERIFICATION FORM</span>
                                    }
                                  </button>
                                </div>
                              }
                            </div>
                            <br>
                              @if (!application.envelopeOkToVerify) {
                                <div class="retrofit-form-text">
                                  <div [innerHTML]="incomeverificationsubmit"></div>
                                </div>
                              }
                              <br>
                                @if (!application.envelopeOkToVerify) {
                                  <div  [ngClass]="{disabledDiv: isSgCheckBoxDisabled(taskSG.statusCode)}">
                                    <mat-checkbox class="retrofit-form-text" id="SubmitChangeReviewedTerms" name="SubmitChangeReviewedTerms"
                                      (change)="onSubmitChangeEventTerms($event)">
                                      <p style="margin: 0;">
                                        I verify that an IVF request has been completed for all income-earners in the household.
                                      </p>
                                    </mat-checkbox>
                                    <div style="margin-top: 18px;">
                                      <button mat-raised-button color="primary" [disabled]="!submitdrawagreeToTerms" (click)="onClickTaxIncomeSubmit()">
                                        SUBMIT
                                      </button>
                                    </div>
                                  </div>
                                }
                              </div>
                            }
                            @if (application.sGStatus ===700000004) {
                              <div class="retrofit-form-text">
                                <div class="retrofit-form-sg-message-qualified" [innerHTML]="sgqualifiedstatusmsg"></div>
                              </div>
                            }
                            @if (application.sGStatus ===700000003) {
                              <div class="retrofit-form-text">
                                <div class="retrofit-form-sg-message-notqualified" [innerHTML]="sgnotqualifiedstatusmsg"></div>
                              </div>
                            }
                          </div>
                        }
                      </div>
                      <div fxFlex="25%">
                        <p class="retrofit-task-help-title" fxShow fxHide.lt-md>Help</p>
                        <mat-divider fxHide fxShow.lt-md style="margin: 9px 0;"></mat-divider>
                        @for (helpLink of helpByTopic('sg'); track helpLink) {
                          <div div>
                            <a class="retrofit-task-help-section-link" href="javascript:void(0)" (click)="onClickShowHelp(helpLink)">
                              {{ helpLink.linkText }}
                            </a>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </mat-expansion-panel>
              }

              <!--Contractor info-->
              @if (this.steps.contractor.show()) {
                <mat-expansion-panel id="contractor-info-panel"
                  [expanded]="this.steps.contractor.expanded()" (opened)="setApprovalTask('contractor')">
                  <mat-expansion-panel-header [collapsedHeight]="'60px'" [expandedHeight]="'60px'">
                    <mat-panel-title>
                      <div>
                        @switch (taskRetrofitContractorStatus.toLowerCase()) {
                          @case ('pending') {
                            <mat-icon class="retrofit-task-icon primary">
                              <div [innerHTML]="loadTaskStatusIconHtml('contractor', taskRetrofitContractorStatus)"></div>
                            </mat-icon>
                          }
                          @case ('permission') {
                            <mat-icon class="retrofit-task-icon primary">  <div [innerHTML]="loadTaskStatusIconHtml('contractor', taskRetrofitContractorStatus)"></div></mat-icon>
                          }
                          @case ('estimate') {
                            <mat-icon class="retrofit-task-icon primary">  <div [innerHTML]="loadTaskStatusIconHtml('contractor', taskRetrofitContractorStatus)"></div></mat-icon>
                          }
                          @case ('selected') {
                            <mat-icon class="retrofit-task-icon accepted"><i class="fa-solid fa-square-check fa-sm"></i></mat-icon>
                          }
                          @case ('rejected') {
                            <mat-icon class="retrofit-task-icon rejected"><i class="fa-solid fa-triangle-exclamation fa-sm"></i></mat-icon>
                          }
                          @case ('updated') {
                            <mat-icon class="retrofit-task-icon accepted"><i class="fa-solid fa-square-check fa-sm"></i></mat-icon>
                          }
                        }
                      </div>
                      <div>
                        <div class="retrofit-task-name">{{taskRetrofitContractorTitle}}</div>
                        <span>
                          @switch (taskRetrofitContractorStatus.toLowerCase()) {
                            @case ('pending') {
                              <small class="retrofit-task-status">
                                Waiting for selection
                              </small>
                            }
                            @case ('permission') {
                              <small class="retrofit-task-status">
                                Waiting for permission
                              </small>
                            }
                            @case ('estimate') {
                              <small class="retrofit-task-status">
                                Waiting for estimate
                              </small>
                            }
                                                   @case ('rejected') {
                            <small class="retrofit-task-status">
                              Action required
                            </small>
                          }
                          @case ('selected') {
                            <small cass="retrofit-task-status accepted">
                              Completed
                            </small>
                          }
                          @default {
                            <small class="retrofit-task-status">
                              {{taskRetrofitContractorStatus}}
                            </small>
                          }
                        }
                      </span>
                    </div>
                  </mat-panel-title>
                  <mat-panel-description fxShow.gt-sm="true" fxShow="false">
                    <span class="retrofit-task-summary todo">
                      {{taskRetrofitContractorSummary}}
                    </span>
                  </mat-panel-description>
                </mat-expansion-panel-header>
                <div class="retrofit-task-body" [ngClass]="{disabledDiv: isreadonly}">
                  <div fxLayout="row" fxLayout.lt-md="column wrap">
                    <div fxFlex='75%'>
                      <ebb-portal-contractor-form [application]="application"
                        [taskBuildingPermit]="taskBuildingPermit"
                        [taskSG]="taskSG"
                        [w9Shown]="this.steps.w9.show()"
                        (emitContractorUpdateEvent)="onEmitContractorUpdate($event)"
                        (emitContractorFileUploadEvent)="onEmitContractorFileUploadEvent($event)"
                        (emitBidInvoiceFileUploadEvent)="onEmitBidInvoiceFileUploadEvent($event)"
                        (emitBidInvoiceInitEvent)="onEmitBidInvoiceInitEvent($event)">
                      </ebb-portal-contractor-form>
                    </div>
                    <div fxFlex='25%'>
                      <p class="retrofit-task-help-title" fxShow fxHide.lt-md>
                        Help
                      </p>
                      <mat-divider fxHide fxShow.lt-md style="margin: 9px 0;"></mat-divider>
                      @for (helpLink of helpByTopic('construction'); track helpLink) {
                        <div>
                          <a class="retrofit-task-help-section-link" href="javascript:void(0)" (click)="onClickShowHelp(helpLink)">
                            {{helpLink.linkText}}
                          </a>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </mat-expansion-panel>
            }
            <!--Ldp info-->


            @if (this.steps.ldp.show()) {
              <mat-expansion-panel id="ldp-info-panel"
                [expanded]="this.steps.ldp.expanded()" (opened)="setApprovalTask('ldp')">
                <mat-expansion-panel-header [collapsedHeight]="'60px'" [expandedHeight]="'60px'">
                  <mat-panel-title>
                    <div>
                      @switch (taskRetrofitLdpStatus.toLowerCase()) {
                        @case ('pending') {
                          <mat-icon class="retrofit-task-icon primary">
                            <div [innerHTML]="loadTaskStatusIconHtml('ldp', taskRetrofitLdpStatus)"></div>
                          </mat-icon>
                        }
                        @case ('permission') {
                          <mat-icon class="retrofit-task-icon primary">  <div [innerHTML]="loadTaskStatusIconHtml('ldp', taskRetrofitLdpStatus)"></div></mat-icon>
                        }
                        @case ('estimate') {
                          <mat-icon class="retrofit-task-icon primary">  <div [innerHTML]="loadTaskStatusIconHtml('ldp', taskRetrofitLdpStatus)"></div></mat-icon>
                        }
                        @case ('selected') {
                          <mat-icon class="retrofit-task-icon accepted"><i class="fa-solid fa-square-check fa-sm"></i></mat-icon>
                        }
                        @case ('rejected') {
                          <mat-icon class="retrofit-task-icon rejected"><i class="fa-solid fa-triangle-exclamation fa-sm"></i></mat-icon>
                        }
                        @case ('updated') {
                          <mat-icon class="retrofit-task-icon accepted"><i class="fa-solid fa-square-check fa-sm"></i></mat-icon>
                        }
                      }
                    </div>
                    <div>
                      <div class="retrofit-task-name">{{taskRetrofitLdpTitle}}</div>
                      <span>
                        @switch (taskRetrofitLdpStatus.toLowerCase()) {
                          @case ('pending') {
                            <small class="retrofit-task-status">
                              Waiting for selection
                            </small>
                          }
                          @case ('permission') {
                            <small class="retrofit-task-status">
                              Waiting for permission
                            </small>
                          }
                          @case ('estimate') {
                            <small class="retrofit-task-status">
                              Waiting for estimate
                            </small>
                          }
                      
                        @case ('rejected') {
                          <small class="retrofit-task-status">
                            Action required
                          </small>
                        }
                        @case ('selected') {
                          <small class="retrofit-task-status accepted">
                            Completed
                          </small>
                        }
                        @default {
                          <small class="retrofit-task-status">
                            {{taskRetrofitLdpStatus}}
                          </small>
                        }
                      }
                    </span>
                  </div>
                </mat-panel-title>
                <mat-panel-description fxShow.gt-sm="true" fxShow="false">
                  <span class="retrofit-task-summary todo">
                    {{taskRetrofitLdpSummary}}
                  </span>
                </mat-panel-description>
              </mat-expansion-panel-header>
              <div class="retrofit-task-body" [ngClass]="{disabledDiv: isreadonly}">
                <div fxLayout="row" fxLayout.lt-md="column wrap">
                  <div fxFlex='75%'>
                    <ebb-portal-ldp-form [application]="application"
                      [taskBuildingPermit]="taskBuildingPermit"
                      (emitLdpUpdateEvent)="onEmitLdpUpdate($event)"
                      (emitLdpFileUploadEvent)="onEmitLdpFileUploadEvent($event)"
                      >
                    </ebb-portal-ldp-form>
                  </div>
                  <div fxFlex='25%'>
                    <p class="retrofit-task-help-title" fxShow fxHide.lt-md>
                      Help
                    </p>
                    <mat-divider fxHide fxShow.lt-md style="margin: 9px 0;"></mat-divider>
                    @for (helpLink of helpByTopic('Design Professional'); track helpLink) {
                      <div>
                        <a class="retrofit-task-help-section-link" href="javascript:void(0)" (click)="onClickShowHelp(helpLink)">
                          {{helpLink.linkText}}
                        </a>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </mat-expansion-panel>
          }
          <!--W-9 form-->
          @if (this.steps.w9.show()) {
            <mat-expansion-panel id="w9-panel"
              [expanded]="this.steps.w9.expanded()" (opened)="setApprovalTask('w9')">
              <mat-expansion-panel-header [collapsedHeight]="'60px'" [expandedHeight]="'60px'">
                <mat-panel-title>
             <mat-icon class="retrofit-task-icon"  [ngClass]="{'accepted':
                                 (taskW9form.statusCode === 700000001 || taskW9form.statusCode === 700000003),
                               'rejected': taskW9form.statusCode === 700000002,
                               'primary': true  }">
                    <div [innerHTML]="loadTaskStatusIconHtml('w9', taskW9form.statusCode)"></div>
                  </mat-icon>
                  <div>
                    <div class="retrofit-task-name">{{taskW9form.name}}</div>
               <small [ngClass]="{'retrofit-task-status accepted': taskW9form.statusCode === 700000001,
                     'retrofit-task-status': true}">
                      {{loadTaskStatusValue('w9', taskW9form.statusCode)}}
                    </small>
                  </div>
                </mat-panel-title>
                <mat-panel-description fxShow.gt-sm="true" fxShow="false">
                  @if (!w9FormSubmitted) {
                    <span class="retrofit-task-summary todo">
                      {{taskW9form.userPrompt}}
                    </span>
                  }
                  @if (w9FormSubmitted) {
                    <span class="retrofit-task-summary todo">
                      {{w9FormPayee}} W-9 data (uploaded)
                    </span>
                  }
                </mat-panel-description>
              </mat-expansion-panel-header>
              <div class="retrofit-task-body" [ngClass]="{disabledDiv: isreadonly}">
                <div fxLayout="row" fxLayout.lt-md="column wrap" fxLayoutGap="25px">
                  <div fxFlex='75%'>
                    @if (!isContractor()) {
                      <div>
                        <p class="retrofit-task-item-title">W-9 information</p>
                        <div class="retrofit-form-text">
                          <div [innerHTML]="w9message"></div>
                        </div>
                        @if (enableW9Form()) {
                          <div style="margin-top: 18px;">
                            <button mat-raised-button color="primary" (click)="onClickSubmitW9data()">
                              COMPLETE W-9 FORM
                            </button>
                          </div>
                        }
                        @if (taskW9form.approvalTaskItems[0].statusCode === 700000002
                          && (taskW9form.approvalTaskItems[0].reasonWhy
                          && taskW9form.approvalTaskItems[0].reasonWhy.length > 0)) {
                          <div style="margin-top: 18px">
                            <p><span class="warn-text">Action required</span>: {{taskW9form.approvalTaskItems[0].reasonWhy}}</p>
                          </div>
                        }
                        @if (w9FormSubmitted) {
                          <div class="retrofit-form-inline-icon-with-label-container">
                            <mat-icon class="retrofit-form-inline-icon-with-label" color="accent">check_circle_outline</mat-icon>
                            <span class="retrofit-form-inline-icon-with-label-text">{{w9FormPayee}} W-9 data submitted on
                            {{w9AuthorizationDate | date: 'M/d/yyyy'}}</span>
                          </div>
                        }
                      </div>
                    }
                    @if (isContractor()) {
                      <div>
                        <p>
                          This section must be completed by homeowner.
                        </p>
                      </div>
                    }
                  </div>
                  <div fxFlex='25%'>
                    <p class="retrofit-task-help-title" fxShow fxHide.lt-md>Help</p>
                    <mat-divider fxHide fxShow.lt-md style="margin: 9px 0;"></mat-divider>
                    @for (helpLink of helpByTopic('payment'); track helpLink) {
                      <div div>
                        <a class="retrofit-task-help-section-link" href="javascript:void(0)" (click)="onClickShowHelp(helpLink)">
                          {{helpLink.linkText}}
                        </a>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </mat-expansion-panel>
          }

          <!-- Sg Bid Invoice -->
          @if (this.steps.bidinvoice.show()) {
            <mat-expansion-panel id="sgbidinvoice-panel"
              [expanded]="this.steps.bidinvoice.expanded()" (opened)="setApprovalTask('bidinvoice')">
              <mat-expansion-panel-header [collapsedHeight]="'60px'" [expandedHeight]="'60px'">
                <mat-panel-title>
                  <div>
                    @switch (taskRetrofitbidInvoiceStatus.toLowerCase()) {
                      @case ('pending') {
                        <mat-icon class="retrofit-task-icon primary">
                          <div [innerHTML]="loadTaskStatusIconHtml('bidinvoice', 0)"></div>
                        </mat-icon>
                      }
                      @case ('invoice') {
                        <mat-icon class="retrofit-task-icon primary"> <div [innerHTML]="loadTaskStatusIconHtml('bidinvoice', 0)"></div></mat-icon>
                      }
                      @case ('selected') {
                        <mat-icon class="retrofit-task-icon accepted"><i class="fa-solid fa-square-check fa-sm"></i></mat-icon>
                      }
                      @case ('rejected') {
                        <mat-icon class="retrofit-task-icon rejected"><i class="fa-solid fa-triangle-exclamation fa-sm"></i></mat-icon>
                      }
                      @case ('updated') {
                        <mat-icon class="retrofit-task-icon accepted"><i class="fa-solid fa-square-check fa-sm"></i></mat-icon>
                      }
                      @case ('approved') {
                        <mat-icon class="retrofit-task-icon accepted"><i class="fa-solid fa-square-check fa-sm"></i></mat-icon>
                      }
                    }
                  </div>
                  <div>
                    <div class="retrofit-task-name">Bid Invoice</div>
                    <span>
                      @switch (taskRetrofitbidInvoiceStatus.toLowerCase()) {
                        @case ('pending') {
                          <small class="retrofit-task-status">
                            Waiting for selection
                          </small>
                        }
                        @case ('invoice') {
                          <small class="retrofit-task-status">
                            Waiting for bid invoice
                          </small>
                        }
                        @case ('rejected') {
                          <small class="retrofit-task-status">
                            Action required
                          </small>
                        }
                        @case ('selected') {
                          <small class="retrofit-task-status accepted">
                            Completed
                          </small>
                        }
                        @case ('approved') {
                          <small class="retrofit-task-status accepted">
                            Approved
                          </small>
                        }
                      }
                    </span>
                  </div>
                </mat-panel-title>
                <mat-panel-description fxShow.gt-sm="true" fxShow="false">
                  <span class="retrofit-task-summary todo">
                    Invoice for receving a bid
                  </span>
                </mat-panel-description>
              </mat-expansion-panel-header>
              <div class="retrofit-task-body" [ngClass]="{disabledDiv: isreadonly}">
                <div fxLayout="row" fxLayout.lt-md="column wrap">
                  <div fxFlex='75%'>
                    @if (!isContractor()) {
                      <div>
                        @if (isSgQualify()) {
                          <ebb-portal-contractor-sg-form [application]="application" [taskSG]="taskSG"
                            [w9Shown]="w9Shown" (emitFileUploadEvent)="onEmitBidInvoiceFileUploadEvent($event)"
                            (emitBidInvoiceApplicationChangeEvent)="onEmitBidInvoiceApplicationChangeEvent($event)"
                            (emitBidInvoiceChoiceEvent)="onEmitBidInvoiceChoiceEvent($event)">
                          </ebb-portal-contractor-sg-form>
                        }
                      </div>
                    }
                    @if (isContractor()) {
                      <div>
                        <p>
                          This section must be completed by homeowner.
                        </p>
                      </div>
                    }
                  </div>
                  <div fxFlex='25%'>
                    <p class="retrofit-task-help-title" fxShow fxHide.lt-md>
                      Help
                    </p>
                    <mat-divider fxHide fxShow.lt-md style="margin: 9px 0;"></mat-divider>
                    @for (helpLink of helpByTopic('Sgbidinvoice'); track helpLink) {
                      <div>
                        <a class="retrofit-task-help-section-link" href="javascript:void(0)" (click)="onClickShowHelp(helpLink)">
                          {{helpLink.linkText}}
                        </a>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </mat-expansion-panel>
          }

          <!-- Sg Permit Receipt -->
          @if (this.steps.permitreceipt.show()) {
            <mat-expansion-panel id="sgpermitreceipt-panel"
              [expanded]="this.steps.permitreceipt.expanded()" (opened)="setApprovalTask('permitreceipt')">
              <mat-expansion-panel-header [collapsedHeight]="'60px'" [expandedHeight]="'60px'">
                <mat-panel-title>
                  <div>
                    @switch (taskRetrofitPermitReceipteStatus.toLowerCase()) {
                      @case ('pending') {
                        <mat-icon class="retrofit-task-icon primary">
                          <div [innerHTML]="loadTaskStatusIconHtml('permitreceipt', 0)"></div>
                        </mat-icon>
                      }
                      @case ('permitreceipt') {
                        <mat-icon class="retrofit-task-icon primary"> <div [innerHTML]="loadTaskStatusIconHtml('permitreceipt', 0)"></div></mat-icon>
                      }
                      @case ('selected') {
                        <mat-icon class="retrofit-task-icon accepted"><i class="fa-solid fa-square-check fa-sm"></i></mat-icon>
                      }
                      @case ('rejected') {
                        <mat-icon class="retrofit-task-icon rejected"><i class="fa-solid fa-triangle-exclamation fa-sm"></i></mat-icon>
                      }
                      @case ('updated') {
                        <mat-icon class="retrofit-task-icon accepted"><i class="fa-solid fa-square-check fa-sm"></i></mat-icon>
                      }
                      @case ('approved') {
                        <mat-icon class="retrofit-task-icon accepted"><i class="fa-solid fa-square-check fa-sm"></i></mat-icon>
                      }
                    }
                  </div>
                  <div>
                    <div class="retrofit-task-name">Permit Receipt</div>
                    <span>
                      @switch (taskRetrofitPermitReceipteStatus.toLowerCase()) {
                        @case ('pending') {
                          <small class="retrofit-task-status">
                            Waiting for information
                          </small>
                        }
                        @case ('permitreceipt') {
                          <small class="retrofit-task-status">
                            Waiting for permit receipt
                          </small>
                        }
                        @case ('rejected') {
                          <small class="retrofit-task-status">
                            Action required
                          </small>
                        }
                        @case ('selected') {
                          <small class="retrofit-task-status accepted">
                            Completed
                          </small>
                        }
                        @case ('approved') {
                          <small class="retrofit-task-status accepted">
                            Approved
                          </small>
                        }
                      }
                    </span>
                  </div>
                </mat-panel-title>
                <mat-panel-description fxShow.gt-sm="true" fxShow="false">
                  <span class="retrofit-task-summary todo">
                    Permit Receipt
                  </span>
                </mat-panel-description>
              </mat-expansion-panel-header>
              <div class="retrofit-task-body" [ngClass]="{disabledDiv: isreadonly}">
                <div fxLayout="row" fxLayout.lt-md="column wrap">
                  <div fxFlex='75%'>
                    @if (!isContractor()) {
                      <div>
                        @if (isSgQualify()) {
                          <ebb-portal-permitreceipt-sg-form [application]="application" [taskSG]="taskSG"
                            [w9Shown]="w9Shown" (emitFileUploadEvent)="onEmitPermitReceiptFileUploadEvent($event)"
                            (emitPermitReceiptApplicationChangeEvent)="onEmitPermitReceiptApplicationChangeEvent($event)"
                            (emitPermitReceiptChoiceEvent)="onEmitPermitReceiptChoiceEvent($event)">
                          </ebb-portal-permitreceipt-sg-form>
                        }
                      </div>
                    }
                    @if (isContractor()) {
                      <div>
                        <p>
                          This section must be completed by homeowner.
                        </p>
                      </div>
                    }
                  </div>
                  <div fxFlex='25%'>
                    <p class="retrofit-task-help-title" fxShow fxHide.lt-md>
                      Help
                    </p>
                    <mat-divider fxHide fxShow.lt-md style="margin: 9px 0;"></mat-divider>
                    @for (helpLink of helpByTopic('Sgpermitreceipt'); track helpLink) {
                      <div>
                        <a class="retrofit-task-help-section-link" href="javascript:void(0)" (click)="onClickShowHelp(helpLink)">
                          {{helpLink.linkText}}
                        </a>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </mat-expansion-panel>
          }

          <!--Permit info-->
          @if (this.steps.permit.show() && getPermitStatus(); as permitStatusCode) {
            <mat-expansion-panel id="permit-info-panel"
              [expanded]="this.steps.permit.expanded()" (opened)="setApprovalTask('permit')">
              <mat-expansion-panel-header [collapsedHeight]="'60px'" [expandedHeight]="'60px'">
                <mat-panel-title>
                  <mat-icon class="retrofit-task-icon"
                  [ngClass]="{'accepted':
                              ((permitStatusCode === 700000001 || permitStatusCode === 700000003) && !waitingForPermitInfo) ||
                              (permitStatusCode === 700000002 && onlyEstimateIsRejected === true),
                              'rejected': 
                              (permitStatusCode === 700000002 && onlyEstimateIsRejected === false),
                              'primary': 
                              true  }">
                    <div [innerHTML]="loadTaskStatusIconHtml('permit', permitStatusCode)"></div>
                  </mat-icon>
                  <div>
                    <div class="retrofit-task-name">{{taskBuildingPermit.name}}</div>
              <small [ngClass]="{'retrofit-task-status accepted': getPermitStatus() === 700000001 && !waitingForPermitInfo,
                                'retrofit-task-status': true}">
                      {{loadTaskStatusValue('permit', getPermitStatus())}}
                    </small>
                  </div>
                </mat-panel-title>
                <mat-panel-description fxShow.gt-sm="true" fxShow="false">
                  <span class="retrofit-task-summary todo">
                    @if (!application.permitIssuer) {
                      <span>
                        {{taskBuildingPermit.userPrompt}}
                      </span>
                    }
                    @if (application.permitIssuer && application.permitIssuer.length > 0) {
                      <span>
                        {{application.permitIssuer}} ({{application.permitNumber}})
                      </span>
                    }
                  </span>
                </mat-panel-description>
              </mat-expansion-panel-header>
              <div class="retrofit-task-body" [ngClass]="{disabledDiv: isreadonly}">
                <div fxLayout="row" fxLayout.lt-md="column wrap" fxLayoutGap="25px">
                  <div fxFlex='75%'>
                    <div class="retrofit-form-text">
                      <div [innerHTML]="textBuildingPermitMessage"></div>
                    </div>
                    <br />
                    <p class="retrofit-task-item-title">Permit Documents</p>
                    <ebb-portal-file-list [context]="'PreRetrofit'" [title]="'Building Permit Files'" [application]="application"
                      [task]="taskBuildingPermit" (emitFileUploadEvent)="onEmitFileUploadEvent($event)">
                    </ebb-portal-file-list>
                    @if (canAddPermitInfo()) {
                      <form [formGroup]="addPermitInfo">
                        <mat-form-field appearance="outline" md-no-float  style="width:100%; max-width: 370px; margin-top: 1em;">
                          <!-- Visible label for users -->
                          <mat-label for="permitTypepreretrofit" aria-owns="permitTypepreretrofit" style="color: #377491; font-weight: 500; text-transform: uppercase;">
                            UPLOAD ADDITIONAL DOCUMENTATION
                          </mat-label>
                          <!-- Fix: Added 'aria-label' for proper screen reader support -->
                          <mat-select
                            (selectionChange)="onPermitAddChange($event)"
                            id="permitTypepreretrofit"
                            name="permitTypepreretrofit"
                            formControlName="permitType"
                            aria-label="Upload Additional Documentation"
                            >
                            @for (item of additionalPermitOptions; track item) {
                              <mat-option [value]="item.label">
                                {{ item.label }}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </form>
                    }
                    @if (progressSaveOptionalPermitDoc) {
                      <div style="margin-top: 12px;">
                        <mat-progress-bar mode="indeterminate" style="width: 300px;"></mat-progress-bar>
                      </div>
                    }
                    <ebb-portal-permit-form
                      [application]="application"
                      [task]="taskBuildingPermit"
                      [permitPlanTypeOptions]="filteredPermitPlanTypeOptions"
                      [saveButtonLabel]="IsSGApplication === true ? 'SAVE & SUBMIT' : 'SAVE'"
                      [isDisabled]="disableBuildingPermitForm()"
                      (emitPermitInfoChangeEvent)="onEmitPermitUpdate($event)">
                    </ebb-portal-permit-form>
                  </div>
                  <div fxFlex='25%'>
                    <p class="retrofit-task-help-title" fxShow fxHide.lt-md>Help</p>
                    <mat-divider fxHide fxShow.lt-md style="margin: 9px 0;"></mat-divider>
                    @for (helpLink of helpByTopic('permit'); track helpLink) {
                      <div div>
                        <a class="retrofit-task-help-section-link" href="javascript:void(0)" (click)="onClickShowHelp(helpLink)">
                          {{helpLink.linkText}}
                        </a>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </mat-expansion-panel>
          }

          <!--House photos-->
          @if (this.steps.house.show()) {
            <mat-expansion-panel id="house-photos-panel-preretrofit"
              [expanded]="this.steps.house.expanded()" (opened)="setApprovalTask('house')">
              <mat-expansion-panel-header [collapsedHeight]="'60px'" [expandedHeight]="'60px'">
                <mat-panel-title>
            <mat-icon class="retrofit-task-icon" [ngClass]="{'accepted':
                                (taskHousePhotos.statusCode === 700000001 || taskHousePhotos.statusCode === 700000003),
                              'rejected': taskHousePhotos.statusCode === 700000002,
                              'primary': true}">
                    <div [innerHTML]="loadTaskStatusIconHtml('house', taskHousePhotos.statusCode)"></div>
                  </mat-icon>
                  <div>
                    <div class="retrofit-task-name">{{taskHousePhotos.name}}</div>
              <small [ngClass]="{'retrofit-task-status accepted': taskHousePhotos.statusCode === 700000001,
                                'retrofit-task-status': true}">
                      {{loadTaskStatusValue('house', taskHousePhotos.statusCode)}}
                    </small>
                  </div>
                </mat-panel-title>
                <mat-panel-description fxShow.gt-sm="true" fxShow="false">
                  <span class="retrofit-task-summary todo">
                    {{taskHousePhotos.userPrompt}}
                    @if (taskHousePhotos.statusCode === 700000001 || taskHousePhotos.statusCode === 700000003) {
                      <span class="retrofit-task-summary todo">
                        (uploaded)
                      </span>
                    }
                  </span>
                </mat-panel-description>
              </mat-expansion-panel-header>
              <div class="retrofit-task-body" [ngClass]="{disabledDiv: isreadonly}">
                <div fxLayout="row" fxLayout.lt-md="column wrap" fxLayoutGap="25px">
                  <div fxFlex='75%'>
                    <ebb-portal-photos [application]="application" [task]="taskHousePhotos" (emitFileUploadEvent)="onEmitFileUploadEvent($event)">
                    </ebb-portal-photos>
                  </div>
                  <div fxFlex='25%'>
                    <p class="retrofit-task-help-title" fxShow fxHide.lt-md>Help</p>
                    <mat-divider fxHide fxShow.lt-md style="margin: 9px 0;"></mat-divider>
                    @for (helpLink of helpByTopic('photos'); track helpLink) {
                      <div div>
                        <a class="retrofit-task-help-section-link" href="javascript:void(0)" (click)="onClickShowHelp(helpLink)">
                          {{helpLink.linkText}}
                        </a>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </mat-expansion-panel>
          }

          <!--Crawl space photos-->
          @if (this.steps.crawlSpace.show()) {
            <mat-expansion-panel id="crawlspace-info-panel"
              [expanded]="this.steps.crawlSpace.expanded()" (opened)="setApprovalTask('crawlSpace')">
              <mat-expansion-panel-header [collapsedHeight]="'60px'" [expandedHeight]="'60px'">
                <mat-panel-title>
            <mat-icon class="retrofit-task-icon" [ngClass]="{'accepted':
                                (taskCrawlspacePhotos.statusCode === 700000001 || taskCrawlspacePhotos.statusCode === 700000003),
                              'rejected': taskCrawlspacePhotos.statusCode === 700000002,
                              'primary': true }">
                    <div [innerHTML]="loadTaskStatusIconHtml('crawlSpace', taskCrawlspacePhotos.statusCode)"></div>
                  </mat-icon>
                  <div>
                    <div class="retrofit-task-name">{{taskCrawlspacePhotos.name}}</div>
              <small [ngClass]="{'retrofit-task-status accepted': taskCrawlspacePhotos.statusCode === 700000001,
                    'retrofit-task-status': true}">
                      {{loadTaskStatusValue('crawlSpace', taskCrawlspacePhotos.statusCode)}}
                    </small>
                  </div>
                </mat-panel-title>
                <mat-panel-description fxShow.gt-sm="true" fxShow="false">
                  <span class="retrofit-task-summary todo">
                    {{taskCrawlspacePhotos.userPrompt}}
                    @if (taskCrawlspacePhotos.statusCode === 700000001 || taskCrawlspacePhotos.statusCode === 700000003) {
                      <span
                        class="retrofit-task-summary todo">
                        (uploaded)
                      </span>
                    }
                  </span>
                </mat-panel-description>
              </mat-expansion-panel-header>
              <div class="retrofit-task-body" [ngClass]="{disabledDiv: isreadonly}">
                <div fxLayout="row" fxLayout.lt-md="column wrap" fxLayoutGap="25px">
                  <div fxFlex='75%'>
                    <ebb-portal-photos [application]="application" [task]="taskCrawlspacePhotos" (emitFileUploadEvent)="onEmitFileUploadEvent($event)">
                    </ebb-portal-photos>
                  </div>
                  <div fxFlex='25%'>
                    <p class="retrofit-task-help-title" fxShow fxHide.lt-md>Help</p>
                    <mat-divider fxHide fxShow.lt-md style="margin: 9px 0;"></mat-divider>
                    @for (helpLink of helpByTopic('photos'); track helpLink) {
                      <div div>
                        <a class="retrofit-task-help-section-link" href="javascript:void(0)" (click)="onClickShowHelp(helpLink)">
                          {{helpLink.linkText}}
                        </a>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </mat-expansion-panel>
          }


          <!--receipts info-->
          @if (this.steps.receipt.show()) {
            <mat-expansion-panel id="receipts-info-panel"
              [expanded]="this.steps.receipt.expanded()" (opened)="setApprovalTask('receipt')">
              <mat-expansion-panel-header [collapsedHeight]="'60px'" [expandedHeight]="'60px'">
                <mat-panel-title>
                  <mat-icon class="retrofit-task-icon"
                [ngClass]="{'accepted':
                            ((taskReceipts.statusCode === 700000001 || taskReceipts.statusCode === 700000003) && !waitingForReceiptInfo),
                            'rejected': 
                            (taskReceipts.statusCode === 700000002),
                            'primary': 
                            true  }">
                    <div [innerHTML]="loadTaskStatusIconHtml('receipt', taskReceipts.statusCode)"></div>
                  </mat-icon>
                  <div>
                    <div class="retrofit-task-name">{{taskReceipts.name}}</div>
                  <small [ngClass]="{'retrofit-task-status accepted': taskReceipts.statusCode === 700000001,
                        'retrofit-task-status': true}">
                      {{loadTaskStatusValue('receipt', taskReceipts.statusCode)}}
                    </small>
                  </div>
                </mat-panel-title>
                <mat-panel-description fxShow.gt-sm="true" fxShow="false">
                  <span class="retrofit-task-summary todo">
                    {{taskReceipts.userPrompt}}
                    @if (taskReceipts.statusCode === 700000001 || taskReceipts.statusCode === 700000003) {
                      <span
                        class="retrofit-task-summary todo">
                        (uploaded)
                      </span>
                    }
                  </span>
                </mat-panel-description>
              </mat-expansion-panel-header>
              <div class="retrofit-task-body" [ngClass]="{disabledDiv: isreadonly}">
                <div fxLayout="row" fxLayout.lt-md="column wrap" fxLayoutGap="25px">
                  <div fxFlex='75%'>
                    <p class="retrofit-task-item-title">Retrofit Receipts</p>
                    <ebb-portal-file-list [context]="'PreRetrofit'" [title]="'Retrofit Receipts'" [application]="application"
                      [task]="taskReceipts" (emitFileUploadEvent)="onEmitFileUploadEvent($event)">
                    </ebb-portal-file-list>
                    <ebb-portal-receipt-preretrofit-form
                      [application]="application"
                      [task]="taskReceipts"
                      (emitReceiptPreretrofitFormChangeEvent)="onEmitReceiptPreretrofitFormUpdate($event)">
                    </ebb-portal-receipt-preretrofit-form>
                  </div>
                  <div fxFlex='25%'>
                    <p class="retrofit-task-help-title" fxShow fxHide.lt-md>Help</p>
                    <mat-divider fxHide fxShow.lt-md style="margin: 9px 0;"></mat-divider>
                    @for (helpLink of helpByTopic('receipts'); track helpLink) {
                      <div div>
                        <a class="retrofit-task-help-section-link" href="javascript:void(0)" (click)="onClickShowHelp(helpLink)">
                          {{helpLink.linkText}}
                        </a>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </mat-expansion-panel>
          }
        </mat-accordion>
      </section>

      <br />

    </div>
